import { render, staticRenderFns } from "./SpaceClosed.vue?vue&type=template&id=346b4a90&scoped=true"
import script from "./SpaceClosed.vue?vue&type=script&lang=ts"
export * from "./SpaceClosed.vue?vue&type=script&lang=ts"
import style0 from "./SpaceClosed.vue?vue&type=style&index=0&id=346b4a90&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b4a90",
  null
  
)

export default component.exports